export const STAFF_PERMISSION_MODULES = {
    basicInformation: 'StaffBasicInformation',
    identificationAndBanking: 'StaffIdentificationAndBanking',
    homeAddress: 'StaffHomeAddress',
    cars: 'StaffCars',
    contacts: 'StaffContacts',
    nextOfKin: 'StaffNextOfKin',
    nextOfKinAddress: 'StaffNextOfKinAddress'
};

// AD-2790: kept out of STAFF_PERMISSION_MODULES, so it does not change which tabs show or whether Edit Profile shows
export const STAFF_CATEGORIES_MODULE = 'StaffCategories';

export const STAFF_SECTION_ACCESS = {
    hide: 'hide',
    view: 'view',
    edit: 'edit'
};

export const getStaffSectionAccess = (permissions, module) => {
    if (permissions.includes(`Permission.${module}.Edit`)) {
        return STAFF_SECTION_ACCESS.edit;
    }

    if (permissions.includes(`Permission.${module}.View`)) {
        return STAFF_SECTION_ACCESS.view;
    }

    return STAFF_SECTION_ACCESS.hide;
};

const staffModuleKeys = Object.values(STAFF_PERMISSION_MODULES);

export const hasAnyVisibleStaffSection = (permissions = []) =>
    staffModuleKeys.some(module => getStaffSectionAccess(permissions, module) !== STAFF_SECTION_ACCESS.hide);

export const hasAnyEditableStaffSection = (permissions = []) =>
    staffModuleKeys.some(module => getStaffSectionAccess(permissions, module) === STAFF_SECTION_ACCESS.edit);
